import { MaterialIcons } from "@expo/vector-icons";
import { Box, Center, Divider, HStack, Icon, Pressable, Text, VStack } from "native-base";
import React from "react";
import { TouchableOpacity } from "react-native";

import MobileHeader from "@/components/molecules/MobileHeader";
import SimpleWebHeader from "@/components/molecules/SimpleWebHeader";
import Container from "@/components/organisms/Container";
import { currentVersion } from "@/utils/platform";

import { options } from "./options";
import { SettingsListItemProps, SettingsProps } from "./types";

const ListItem = ({ iconName, title, onPress }: SettingsListItemProps) => {
  return (
    <Pressable
      onPress={onPress}
      p="4"
      m="2"
      shadow="4"
      bgColor="white.50"
      w="230px"
      borderRadius="md"
      justifyContent="center"
      alignItems="center">
      <Icon as={<MaterialIcons name={iconName as any} />} color="primary.600" size="4xl" />
      <Text py="4">{title}</Text>
    </Pressable>
  );
};

const SettingsWeb = ({ userName, onBackPress, onPressLogout, onOptionPress }: SettingsProps) => {
  return (
    <Container Header={<SimpleWebHeader />}>
      <Box py="4">
        <MobileHeader
          title="Ajustes"
          showLogo={false}
          shadow="none"
          onBackPress={() => onBackPress()}
        />
      </Box>
      <VStack bgColor="white.50" p="4" shadow="4" rounded="md">
        <Text fontSize="lg" color="primary.600" py="4" bold>
          Olá, {userName}
        </Text>
        <Divider />
        {options.map(({ session, options }) => (
          <VStack key={session} py="2">
            <Text fontSize="md" py="4" color="primary.600">
              {session}
            </Text>
            <HStack space="4" flexWrap="wrap">
              {options.map((option) => (
                <ListItem
                  key={option.title}
                  title={option.title}
                  iconName={option.iconName}
                  onPress={() => onOptionPress(option)}
                />
              ))}
            </HStack>
          </VStack>
        ))}
      </VStack>
      <Center py="4">
        <TouchableOpacity onPress={onPressLogout}>
          <VStack py="4" pt="8" alignItems="center">
            <Icon as={<MaterialIcons name="logout" />} color="red.600" size="lg" />
            <Text px="4" color="red.600">
              Sair
            </Text>
          </VStack>
        </TouchableOpacity>
        <Text>iFeira v{currentVersion}</Text>
      </Center>
    </Container>
  );
};

export default SettingsWeb;
